/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';
import { Close } from '@mui/icons-material';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  IconButton,
} from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import useCWPContext from '../context/useCWPContext';

function CwpDetailsModal() {
  const {
    auth,
    activeTab,
    cwpDetails,
    setCwpDetails,
    handleCwpDetailStatus,
    handleUpdateCwpAppointment,
  } = useContext(useCWPContext);

  const actionButton =
    activeTab === 0 || (activeTab === 1 && auth.designation === 'admin')
      ? [
          {
            field: 'approved',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            headerName: 'Approved',
            width: 50,
            filterable: false,
            sortable: false,
            renderCell: ({ row }) => (
              <div>
                <input
                  name={`${row.id}-status`}
                  id={`${row.id}-status-approve`}
                  type='checkbox'
                  value='1'
                  checked={row.approve_status}
                  onClick={(e) => handleCwpDetailStatus(e, 1, row)}
                />
              </div>
            ),
          },
          {
            field: 'reject',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            headerName: 'Reject',
            width: 50,
            filterable: false,
            sortable: false,
            renderCell: ({ row }) => (
              <div>
                <input
                  name={`${row.id}-status`}
                  id={`${row.id}-status-reject`}
                  type='checkbox'
                  value='3'
                  checked={row.reject_status}
                  onClick={(e) => handleCwpDetailStatus(e, 3, row)}
                />
              </div>
            ),
          },
        ]
      : [];
  const columns = [
    { field: 'hospital_name', flex: 1, headerName: 'Hostpital Name', width: 200 },
    { field: 'point_person_name', flex: 1, headerName: 'Point Person', width: 200 },
    { field: 'point_person_designation', flex: 1, headerName: 'Designation', width: 200 },
    { field: 'appointment_date', flex: 1, headerName: 'Appointment Date', width: 200 },
    ...actionButton,
  ];

  const handleClose = () => {
    setCwpDetails({ ...cwpDetails, toggle: false });
  };

  return (
    <Dialog onClose={handleClose} open={cwpDetails.toggle} fullWidth maxWidth='md'>
      <DialogTitle sx={{ m: 0, p: 2 }}>
        CWP Details
        <IconButton
          aria-label='close'
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <div style={{ marginBottom: 3, height: '550px', position: 'relative' }}>
          <DataGridPro rows={cwpDetails.data} columns={columns} />
        </div>
      </DialogContent>
      <DialogActions>
        {activeTab === 0 || (activeTab === 1 && auth.designation === 'admin') ? (
          <Button variant='contained' color='success' onClick={handleUpdateCwpAppointment}>
            Submit
          </Button>
        ) : (
          ''
        )}
        <Button variant='contained' color='error' onClick={handleClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CwpDetailsModal;
